export default "__VITE_ASSET__4bca2fad__"